import React, { useState } from 'react';
import { incidentsAPI } from '../../api/traceability';
import { captureLocation } from '../../lib/fieldOperation';
import { errorMessage } from '../../lib/evaluationIntegrity';
import ZoneSelector from '../ZoneSelector';

export default function IncidentEvidence({ incident, zones, onChanged }) {
  const [pending, setPending] = useState(null);
  const [zone, setZone] = useState(incident.zone || null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  async function upload(capture) {
    setBusy(true);
    setError('');
    try {
      const geo = capture.geo === undefined ? await captureLocation() : capture.geo;
      const next = { ...capture, geo };
      setPending(next);
      if (!geo && !zone?.id) {
        setError('Selecciona una zona para cargar la foto sin GPS.');
        return;
      }
      await incidentsAPI.evidence(incident.id, next.file, {
        client_evidence_id: next.id, captured_at: next.captured_at,
        lat: geo?.lat, lng: geo?.lng, accuracy_m: geo?.accuracy_m, geo_source: geo?.source || 'none',
        zone_id: zone?.id, zone_detail: zone?.detail,
      });
      setPending(null);
      await onChanged?.();
    } catch (err) {
      // Solo una ruta inexistente (405, o 404 genérico "Not Found") indica un
      // servidor sin esta función; un 404 con detalle propio es un error real.
      const status = err?.response?.status;
      const routeMissing = status === 405 || (status === 404 && err?.response?.data?.detail === 'Not Found');
      setError(routeMissing
        ? 'La carga de fotos no está disponible. Actualiza el servidor y reintenta; la foto sigue pendiente.'
        : errorMessage(err, 'No se pudo cargar la foto'));
    }
    finally { setBusy(false); }
  }
  return <fieldset disabled={busy} className="space-y-2">
    <ZoneSelector zones={zones} zone={zone} onChange={setZone} />
    <label>Foto de incidencia<input type="file" accept="image/*" disabled={!!pending}
      onChange={e => {
        const file = e.target.files?.[0];
        if (file) upload({ file, id: crypto.randomUUID(), captured_at: new Date().toISOString() });
        e.target.value = '';
      }} /></label>
    {pending && <div><p>Foto pendiente: {pending.file.name}</p>
      <button type="button" onClick={() => upload(pending)}>Reintentar foto</button>
      <button type="button" onClick={() => setPending(null)}>Descartar carga pendiente</button></div>}
    {error && <p role="alert">{error}</p>}
  </fieldset>;
}
